var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.707 7.534a1 1 0 000 1.414L7.37 15.61a.601.601 0 00.02.02l.008.009a1 1 0 001.557-.18l6.665-6.665a1 1 0 10-1.414-1.414l-6.119 6.119-5.966-5.965a1 1 0 00-1.414 0z",
    fill: "#3555F0"
  })));
}

export default __webpack_public_path__ + "./fonts/arrow.2e9c05cec38e03b2fcae8e5c680e0958.svg";
export { SvgArrow as ReactComponent };